module.exports = __webpack_public_path__ + "static/media/Font Awesome 5 Pro 400.5d0b8acb.otf";